enum AppeasementResponsibility {
    Client = 'Client',
    GroupO = 'GroupO',
}

export default AppeasementResponsibility;
